interface DuplicateMatch {
    expense_id: string;
    provider: string;
    amount: number;
    date_of_service: string;
    match_score: number;
    match_reasons: string[];
}

interface Props {
    matches: DuplicateMatch[];
    onMerge: (targetId: string) => void;
    onKeepSeparate: () => void;
    onCancel: () => void;
}

export default function DuplicateReviewModal({ matches, onMerge, onKeepSeparate, onCancel }: Props) {
    return (
        <div className="modal-overlay" role="dialog" aria-modal="true" aria-labelledby="duplicate-title">
            <div className="modal duplicate-modal">
                <h2 id="duplicate-title">⚠️ Potential Duplicate Detected</h2>
                <p className="modal-description">
                    We found existing expenses that may match this one. What would you like to do?
                </p>

                <div className="duplicate-matches">
                    {matches.map((match) => (
                        <div key={match.expense_id} className="duplicate-match-card">
                            <div className="match-header">
                                <span className="match-score">{match.match_score}% Match</span>
                            </div>
                            <div className="match-details">
                                <div className="match-field">
                                    <span className="label">Provider:</span>
                                    <span className="value">{match.provider}</span>
                                </div>
                                <div className="match-field">
                                    <span className="label">Amount:</span>
                                    <span className="value">${match.amount.toFixed(2)}</span>
                                </div>
                                <div className="match-field">
                                    <span className="label">Date:</span>
                                    <span className="value">{match.date_of_service}</span>
                                </div>
                                <div className="match-reasons">
                                    <span className="label">Reasons:</span>
                                    <ul>
                                        {match.match_reasons.map((reason, i) => (
                                            <li key={i}>{reason}</li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                            <button
                                onClick={() => onMerge(match.expense_id)}
                                className="btn btn-primary"
                            >
                                Merge with this expense
                            </button>
                        </div>
                    ))}
                </div>

                <div className="modal-actions">
                    <button onClick={onKeepSeparate} className="btn btn-secondary">
                        Keep as Separate Expense
                    </button>
                    <button onClick={onCancel} className="btn btn-ghost">
                        Cancel
                    </button>
                </div>
            </div>
        </div>
    );
}
